module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', [_vm._v("Glossary")]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('b', [_vm._v("arles")]), _vm._v(": when two people strike a bargain in goods or services, the purchaser gives arles, a money payment to show that she is in good faith")]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('b', [_vm._v("backland")]), _vm._v(": the part of a burgh plot that stretches behind the main house")]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('b', [_vm._v("bowyer")]), _vm._v(": one who makes bows for archers")]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('b', [_vm._v("brewster")]), _vm._v(": a woman who brews ale")]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('b', [_vm._v("canon")]), _vm._v(": in some religious orders, including the Augustinian order, the priests were called canons; Holyrood and Soutra were Augustinian houses")]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('b', [_vm._v("card weaving")]), _vm._v(": also called tablet weaving, an ancient technique for weaving bands that predates loom weaving. A set of cards with four holes are threaded for the warp, each hole in each card carrying a single warp thread; the space between these holes creates the shed. As the cards are turned one-quarter, individually or in clusters, new threads are brought to the surface making the pattern. The warps twist, or twine around the weft, completely covering it. The cards are often made of bone or wood.")]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('b', [_vm._v("close")]), _vm._v(": a pathway between burgh properties larger than an alley but not public (see ‘wynd’)")]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('b', [_vm._v("cruisie")]), _vm._v(": an oil lamp with a rush wick")]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('b', [_vm._v("Edward Longshanks")]), _vm._v(": King Edward I was long-legged, hence the nickname")]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('b', [_vm._v("factor")]), _vm._v(": one who buys and sells for another person; a mercantile agent; a commission merchant")]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('b', [_vm._v("flyting")]), _vm._v(": scolding")]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('b', [_vm._v("gate")]), _vm._v(": street")]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('b', [_vm._v("gey")]), _vm._v(": very")]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('b', [_vm._v("gooddaughter")]), _vm._v(": daughter-in-law")]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('b', [_vm._v("goodmother")]), _vm._v(": mother-in-law")]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('b', [_vm._v("kirtle")]), _vm._v(": a gown laced at the bodice that served as an undergarment")]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('b', [_vm._v("lugs")]), _vm._v(": ears")]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('b', [_vm._v("lyke")]), _vm._v(": corpse")]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('b', [_vm._v("lykewake")]), _vm._v(": the watch over the corpse")]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('b', [_vm._v("merrills")]), _vm._v(": a popular board game with a board containing holes and pegs that the players moved in the manner of tic-tac-toe or noughts and crosses")]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('b', [_vm._v("Pater Noster beads")]), _vm._v(": rosary beads")]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('b', [_vm._v("pattens")]), _vm._v(": wooden platforms attached to shoes for walking in mud")]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('b', [_vm._v("plaid")]), _vm._v(": vari-coloured wool cloth, precursor to the tartan but linked to an area only by the dyes available to weavers")]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('b', [_vm._v("port")]), _vm._v(": gate")]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('b', [_vm._v("queyn")]), _vm._v(": girl")]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('b', [_vm._v("Ragman")]), _vm._v(" "), _c('b', [_vm._v("Rolls")]), _vm._v(": an oath of fealty to Edward I signed by Scots, dated 28 September 1296, Berwick")]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('b', [_vm._v("scarlett")]), _vm._v(": the finest cloth, not necessarily red in colour")]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('b', [_vm._v("scrip")]), _vm._v(": a small bag, wallet, or satchel")]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('b', [_vm._v("siller")]), _vm._v(": money (from ‘silver’)")]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('b', [_vm._v("smiddie")]), _vm._v(": smithy")]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('b', [_vm._v("trencher")]), _vm._v(": a thick slice of brown bread a few days old with a slight hollow in the centre, used as a platter")]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('b', [_vm._v("tron")]), _vm._v(": the marketplace weigh beam for weighing goods")]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('b', [_vm._v("wean")]), _vm._v(": baby")]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('b', [_vm._v("wynd")]), _vm._v(": a more public alley between burgh properties than a close")]), _vm._v(" "), _c('div', {
    staticClass: "figure"
  }, [_c('img', {
    attrs: {
      "alt": "Trust_Betrayed_map_page1",
      "src": "Images/Trust_Betrayed_map_page1.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "figure"
  }, [_c('img', {
    attrs: {
      "alt": "Trust_Betrayed_map_page2",
      "src": "Images/Trust_Betrayed_map_page2.jpg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-173c963c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/TB_glossary.vue
// module id = 75
// module chunks = 0